<template>
    <div>
        <b-button-group size="sm">
            <b-button
                    :class="{'active': markupType === null}"
                    @click="doSubmit(null, null)"
            >
                Implicit
            </b-button>

            <b-button :class="{'active': isManual}" @click="showModal">
                Manual <span class="value-tooltip" v-if="isManual">{{ getManualString }}</span>
            </b-button>
        </b-button-group>

        <b-modal ref="my-modal" hide-footer title="Alege tipul de adaos">
            <div role="tablist">
                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-1 variant="info" @click="onReset">Valoare exactă</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>Setează exact valoarea în RON</b-card-text>
                            <b-form @submit="onSubmit" inline class="justify-content-between">
                                <b-input-group size="sm">
                                    <b-form-input
                                            size="sm"
                                            type="number"
                                            step="0.01"
                                            placeholder="Introdu o sumă"
                                            v-model="exact"
                                            required>
                                    </b-form-input>
                                </b-input-group>

                                <b-button type="submit" variant="success" size="sm">
                                    Salvează <span class="value-tooltip" v-if="exact">({{ parseFloat(exact).toFixed(2) }})</span>
                                </b-button>
                            </b-form>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-2 variant="info" @click="onReset">Procentaj</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>Modifică valoarea în RON cu un procentaj</b-card-text>
                            <b-form @submit="onSubmit" inline class="justify-content-between">
                                <b-input-group size="sm" :prepend="parseFloat(basePrice).toFixed(2) + ' +'" append="%">
                                    <b-form-input
                                            size="sm"
                                            type="number"
                                            step="0.01"
                                            placeholder="Introdu un procentaj"
                                            v-model="percentage"
                                            required>
                                    </b-form-input>
                                </b-input-group>

                                <b-button type="submit" variant="success" size="sm">
                                    Salvează <span class="value-tooltip" v-if="percentage">({{ (parseFloat(basePrice) * (100 + parseFloat(this.percentage)) / 100).toFixed(2) }})</span>
                                </b-button>
                            </b-form>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-3 variant="info" @click="onReset">Adaos fix</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>Adaugă o sumă fixă la valoarea în RON</b-card-text>
                            <b-form @submit="onSubmit" inline class="justify-content-between">
                                <b-input-group size="sm" :prepend="parseFloat(basePrice).toFixed(2) + ' +'" >
                                    <b-form-input
                                            size="sm"
                                            type="number"
                                            step="0.01"
                                            placeholder="Introdu o sumă"
                                            v-model="absolute"
                                            required>
                                    </b-form-input>
                                </b-input-group>

                                <b-button type="submit" variant="success" size="sm">
                                    Salvează <span class="value-tooltip" v-if="absolute">({{ (parseFloat(basePrice) + parseFloat(this.absolute)).toFixed(2) }})</span>
                                </b-button>
                            </b-form>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>
            <b-button class="mt-3" variant="outline-danger" block @click="hideModal">Anulare</b-button>
        </b-modal>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                percentage: null,
                absolute: null,
                exact: null,
            }
        },
        name: "ProductMarkupPicker",
        methods: {
            showModal() {
                this.$refs['my-modal'].show()
            },
            hideModal() {
                this.$refs['my-modal'].hide()
            },
            onReset(evt) {
                if(evt) evt.preventDefault()

                this.percentage = null;
                this.absolute = null;
                this.exact = null;
            },
            onSubmit(evt) {
                evt.preventDefault()

                if(this.percentage)
                    this.doSubmit('PERCENTAGE', this.percentage)
                else if(this.absolute)
                    this.doSubmit('ABSOLUTE', this.absolute)
                else if(this.exact)
                    this.doSubmit('EXACT', this.exact)
                else
                    this.doSubmit(null, null)

                this.onReset()
                this.hideModal()
            },
            doSubmit(markupType, markup) {
                this.$emit('selected', {
                    itemId: this.itemId,
                    markupType,
                    markup,
                });
            }
        },
        props: [
            'itemId',
            'basePrice',
            'markupType',
            'markup'
        ],
        computed: {
            isManual() {
                return this.markupType !== null;
            },
            getManualString() {
                if(!this.isManual) return null;

                if(this.markupType === "PERCENTAGE") return `+${this.markup}%`;
                if(this.markupType === "ABSOLUTE") return `+${this.markup}`;
                if(this.markupType === "EXACT") return `=${this.markup}`;

                return null;
            }
        }
    }
</script>

<style scoped>
    .value-tooltip {
        color: #ffffff8f;
        font-size: small;
    }
</style>